<template>
  <div
    class="gradation"
    :class="{otherColor: otherColor}"
    @click.stop="handleSquareBtnClick"
  >
    <span class="text" :class="className">{{text}}
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'SKIP',
    },
    className: {
      type: String,
      default: '',
    },
    otherColor: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.gradation{
  font-size: 24px;
  font-weight: 700;
  background-color: $mainColor;
  color: $white;
  padding: 10px 20px;
  cursor: pointer;
  transition: 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  text-transform: uppercase;
  .text{
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
  }
  .large {
    font-size: 18px!important;
    font-weight: bold;
  }
  &:hover {
    opacity: 0.6;
  }
}
.otherColor{
  background-color: $yellow;
}
@media screen and  (max-width: $tabletWidth) {
  .gradation{
    .text{
      font-size: 14px;
    }
    &:hover {
      opacity: 1;
    }
  }
}
</style>
